import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { fonts, colors, layout } from "../../theme/tokens";
import { statCards } from "../../data/siteData";

const StatsBand = () => {
  const ref = useRef(null);
  const [counts, setCounts] = useState(statCards.map(() => 0));
  const doneRef = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !doneRef.current) {
            doneRef.current = true;
            const start = performance.now();
            const dur = 1500;
            const tick = (now) => {
              const p = Math.min(1, (now - start) / dur);
              const e = 1 - Math.pow(1 - p, 3);
              setCounts(statCards.map((c) => Math.round(c.target * e)));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
            io.disconnect();
          }
        });
      },
      { threshold: 0.35 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Box
      component="section"
      sx={{ px: { xs: "20px", md: "28px" }, pt: "30px", pb: "64px" }}
    >
      <Box
        ref={ref}
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          background: "linear-gradient(155deg,#1E3A57,#0E1B2A)",
          borderRadius: "30px",
          p: { xs: "40px 28px", md: "54px 48px" },
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-100px",
            right: "-60px",
            width: "340px",
            height: "340px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle,rgba(246,166,35,.18),transparent 65%)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4,1fr)" },
            gap: "30px",
          }}
        >
          {statCards.map((c, i) => (
            <Box key={c.label}>
              <Box
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 700,
                  fontSize: "clamp(38px,4.6vw,58px)",
                  lineHeight: 1,
                  color: "#fff",
                }}
              >
                {counts[i]}
                <Box component="span" sx={{ color: colors.amberDot }}>
                  {c.suffix}
                </Box>
              </Box>
              <Box
                sx={{
                  mt: "10px",
                  fontFamily: fonts.body,
                  fontSize: "14px",
                  color: "#9FB2C6",
                  fontWeight: 500,
                  maxWidth: "160px",
                }}
              >
                {c.label}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default StatsBand;
